import {connect} from 'react-redux';
import UploadedFile from './UploadedFile';
import {getFile} from '../../../modules/Inspection/actions/files/getFile';
import {getFileFromOrder} from '../../actions/files/getFile';
import {deleteFile} from '../../../modules/Inspection/actions/files/deleteFile';
import {getFileList} from '../../../modules/Inspection/actions/files/getFileList';
import {showGlobalErrorMessage} from '../../actions/globalErrorMessage/showGlobalErrorMessage';

export default connect(
  null,
  {
    getFile,
    getFileFromOrder,
    deleteFile,
    getFileList,
    showGlobalErrorMessage
  }
)(UploadedFile);
